module.exports = __webpack_public_path__ + "static/media/logo.723ab85b.png";